import { createContext, useContext, useEffect, useState } from 'react';

// Note: matched to actual grid usablewidth (not width of screen)
export const containerBreakpoints = {
  lg: 1173,
  md: 814,
  sm: 660
};

export type BreakpointKey = 'sm' | 'md' | 'lg';

interface BreakpointContextType {
  breakpoint: BreakpointKey;
  setBreakpoint: (bp: BreakpointKey) => void;
}

const BreakpointContext = createContext<BreakpointContextType | undefined>(undefined);

export const BreakpointProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [breakpoint, setBreakpoint] = useState<BreakpointKey>(() => {
    return getBreakPoint();
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakPoint());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <BreakpointContext.Provider value={{ breakpoint, setBreakpoint }}>
      {children}
    </BreakpointContext.Provider>
  );
};

const getBreakPoint = (): BreakpointKey => {
  const width = window.innerWidth;
  if (width >= 1400) return 'lg';
  if (width >= 995) return 'md';
  return 'sm';
};

export const useBreakpoint = (): BreakpointContextType => {
  const context = useContext(BreakpointContext);
  if (!context) {
    throw new Error('useBreakpoint must be used within a BreakpointProvider');
  }
  return context;
};
